import React from 'react';
import { FormattedMessage } from 'react-intl';

// Hooks
import { useModal } from '../../../../hooks';
import usePlanSummary from '../hooks/usePlanSummary';

// Styles
import { StyledDd, StyledDl, StyledDt, StyledSpan } from '../plansummary.styled';

// Components
import { GIButton } from 'app-components';
import { enrollmentStatusMap } from '../planSummary.constants';

const PaymentLink = ({ plan }) => {
    const { openModal } = useModal();
    const { payForPlan } = usePlanSummary();

    const shouldShow =
        plan.disEnroll &&
        plan.paymentUrl &&
        plan.enrollmentStatus &&
        plan.enrollmentStatus.toUpperCase() === enrollmentStatusMap.PENDING.toUpperCase() &&
        Number(plan.netPremium) !== 0;

    if (!shouldShow) {
        return null;
    }

    const onPayNowClick = () => {
        payForPlan(
            {
                caseNumber: plan.caseNumber,
                typeOfPlan: plan.typeOfPlan,
                enrollmentId: plan.enrollmentId,
            },
            openModal,
        );
    };

    return (
        <>
            <StyledDl>
                <StyledDt as="dt" data-testid="payment-url-label">
                    <StyledSpan>
                        <FormattedMessage id="plansummary.paymenturl" />
                    </StyledSpan>
                    <span>:</span>
                </StyledDt>
                <StyledDd as="dd">
                    <GIButton
                        id="pay-health-insurance_btn"
                        data-testid="pay-health-insurance-button"
                        labelId="plansummary.payForHealthPlan"
                        onClickHandler={onPayNowClick}
                    />
                </StyledDd>
            </StyledDl>
        </>
    );
};

export default PaymentLink;
